var render = function render(){var _vm=this,_c=_vm._self._c;return _c('review-board',{attrs:{"course-source":"Normal"}})
}
var staticRenderFns = []

export { render, staticRenderFns }